module.exports = __webpack_public_path__ + "img/horacio.861edac0.png";